// Admin Reducers Index
import adminAuthReducer from "./adminAuthReducer";
import adminDashboardReducer from "./adminDashboardReducer";
import adminUserManagementReducer from "./adminUserManagementReducer";
import adminApiKeysManagementReducer from "./adminApiKeysManagementReducer";
import adminContentManagementReducer from "./adminContentManagementReducer";
import adminSupportReducer from "./adminSupportReducer";

const adminReducers = {
  ADMIN_AUTH: adminAuthReducer,
  ADMIN_DASHBOARD: adminDashboardReducer,
  ADMIN_USER_MANAGEMENT: adminUserManagementReducer,
  ADMIN_API_KEYS_MANAGEMENT: adminApiKeysManagementReducer,
  ADMIN_SUPPORT: adminSupportReducer,
  ADMIN_CONTENT_MANAGEMENT: adminContentManagementReducer,
};

export default adminReducers;
